import { useState, FC, useEffect } from "react"
import JoinModal from "./JoinModal"
import { Button } from "../ui/button"

interface JoinProps {
  isQuick: boolean
  guestRoomCode: string
  hostRoomCode: string
  isHost: any
  isDisabled: boolean
  joinSession: () => void
}
const JoinButton: FC<JoinProps> = ({
  guestRoomCode,
  hostRoomCode,
  isQuick,
  isDisabled,
  isHost,
  joinSession,
}) => {
  const [dynamicURL, setDynamicURL] = useState<string | null>(null)
  const [openModal, setOpenModal] = useState(false)

  const prefix = process.env.REACT_APP_VIDEO_PREFIX
  const quickPrefix = process.env.REACT_APP_VIDEO_PREFIX_QUICK

  const hostUrl = `https://${prefix}.app.100ms.live/meeting/${hostRoomCode}`
  const quickHostUrl = `https://${quickPrefix}.app.100ms.live/meeting/${hostRoomCode}`

  const guestUrl = `https://${prefix}.app.100ms.live/meeting/${guestRoomCode}`
  const quickGuestUrl = `https://${quickPrefix}.app.100ms.live/meeting/${guestRoomCode}`

  const setUserUrl = () => {
    let url: string
    try {
      if (isQuick) {
        if (isHost) {
          url = quickHostUrl
        } else {
          url = quickGuestUrl
        }
      } else {
        if (isHost) {
          url = hostUrl
        } else {
          url = guestUrl
        }
      }
      setDynamicURL(url)
    } catch (error) {
      console.error("Error fetching host or guest room code", error)
    }
  }

  const handleClick = () => {
    if (dynamicURL) {
      window.open(dynamicURL, "_blank", "noopener noreferrer")
      joinSession()
      setOpenModal(true)
    } else {
      console.warn("Dynamic URL is not yet available.")
    }
  }

  useEffect(() => {
    setUserUrl()
  }, [isHost, isQuick, hostRoomCode, guestRoomCode])

  return (
    <>
      <Button onClick={handleClick} disabled={isDisabled || !dynamicURL}>
        {dynamicURL && isDisabled ? "Waiting for Host" : "Join Room"}
      </Button>
      {openModal && <JoinModal setOpenModal={setOpenModal} dynamicURL={dynamicURL}/>}
    </>
  )
}
export default JoinButton
